'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:log:mge');
}

var _invoke = require('../invoke');

/**
 * 发送 mge 统计参数
 *
 * 支持版本
 * + iHotel/5.8+
 *
 * @memberof log
 * @static
 * @name mge
 * @param {String | Undefined} cid 页面名
 * @param {String | Undefined} act 事件名
 * @param {String | Undefined} val 页面属性
 * @param {String | Undefined} lab 事件属性
 * @return {Undefined}
 * @example
 *  hbnb.log.mge('页面A', '点击事件B');
 *  hbnb.log.mge({
 *      cid: '页面A‘，
 *      act: '点击事件B'
 *  });
 */

module.exports = function(cid, act, val, lab) {
    if (process.env.NODE_ENV !== 'production') {
        debug('cid = %s', cid);
        debug('act = %s', act);
        debug('val = %s', val);
        debug('lab = %s', lab);
    }

    if (typeof cid === 'object') {
        var opt = cid;
        cid = String(opt.cid || '');
        act = String(opt.act || opt.action);
        val = String(opt.val || opt.value);
        lab = String(opt.lab || opt.label);
    }

    _invoke('log', 'mge', {
        cid: cid || '',
        action: act || '',
        value: val || '',
        label: lab || ''
    });
};



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@hfe/hbnb/log/mge.js
// module id = 602
// module chunks = 0